import { render, staticRenderFns } from "./RectangularTrapezoidVertical.vue?vue&type=template&id=2d236f2a&scoped=true&"
import script from "./RectangularTrapezoidVertical.vue?vue&type=script&lang=js&"
export * from "./RectangularTrapezoidVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d236f2a",
  null
  
)

export default component.exports